module.exports = __webpack_public_path__ + "img/location_2.69796c02.png";